import { DownOutlined } from '@ant-design/icons'
import { Avatar, Dropdown, Layout, Typography, Popover } from 'antd'
import { bool, string } from 'prop-types'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import NotificationIcon from 'components/notification/icon'
import NotificationModal from 'components/notification/NotificationModal'
import LogOutContext from '~/context/LogOutContext'
import { classNames } from '~/utils'
import { signOut } from 'services/auth'
import { getNotifications } from 'services/notifications'

import styles from './index.module.scss'

const { Text } = Typography

function Head({ isWeb, className }) {
	const history = useHistory()
	const [open, setOpen] = useState(false)
	const [unreadCount, setUnreadCount] = useState(0)
	const {
		name: username,
		signatures_provider,
		company,
	} = useSelector(({ session }) => session)

	useEffect(() => {
		if (company?.config?.has_demands) {
			const checkUnread = async () => {
				try {
					const data = await getNotifications(1, 1, 'unread')
					setUnreadCount(data.counts?.unread || 0)
				} catch (error) {
					console.error(error)
				}
			}
			checkUnread()
		}
	}, [company])

	const logout = useContext(LogOutContext)
	const handleLogout = async () => {
		try {
			const userContracts = JSON.parse(localStorage.getItem('user-contracts'))
			if (userContracts) {
				await signOut()

				window.location = '/'
			} else {
				await logout()
			}
		} catch (e) {
			console.log(e)
		}
	}

	const checkDocusign = () => {
		window.location.assign(
			process.env.REACT_APP_DOCUSIGN_OAUTH_URL +
				'/auth?response_type=code&scope=signature&client_id=' +
				process.env.REACT_APP_DOCUSIGN_INTEGRATION_KEY +
				'&redirect_uri=' +
				process.env.REACT_APP_DOCUSIGN_REDIRECT_URL
		)
	}

	const items = useMemo(() => {
		const items = [
			{
				key: '2',
				label: 'sair',
				onClick: handleLogout,
			},
		]
		if (signatures_provider === 'docusign') {
			items.unshift({
				key: '1',
				label: 'Docusign login',
				onClick: checkDocusign,
			})
		}
		return items
	}, [signatures_provider, handleLogout])

	const handleOpenChange = (newOpen) => {
		setOpen(newOpen)
	}

	const closePopover = () => {
		setOpen(false)
	}

	const { Header } = Layout

	return (
		<Header className={classNames(styles.siteLayout, className)}>
			<div
				className={classNames(styles.profile, {
					[styles.profileMobile]: !isWeb,
				})}>
				{company?.config?.has_demands && (
					<Popover
						content={<NotificationModal onClose={closePopover} />}
						trigger="click"
						open={open}
						onOpenChange={handleOpenChange}
						placement="bottomRight"
						arrow={false}
						overlayClassName={styles.popoverNotification}>
						<div
							style={{
								cursor: 'pointer',
								display: 'flex',
								alignItems: 'center',
							}}>
							<NotificationIcon count={unreadCount} />
						</div>
					</Popover>
				)}
				{/* Removed for now because the youtube help channel is not updated */}
				{/* <a
					className={styles['iconsHeader']}
					href='https://www.youtube.com/channel/UCarjXS9zL3-xJqHI5JsidFw'
					target='_blank'>
					<QuestionCircleOutlined />
				</a> */}
				<Dropdown menu={{ items }} trigger={['click']}>
					<div className={styles['dropDownProfile']}>
						<Avatar>
							<Text>{username ? username.substring(0, 1) : username}</Text>
						</Avatar>
						<Text>{username}</Text>
						<DownOutlined />
					</div>
				</Dropdown>
			</div>
		</Header>
	)
}

Head.propTypes = {
	isWeb: bool,
	className: string,
}

Head.deafultProps = {
	isWeb: true,
	className: '',
}

export default Head
